import { render } from "./secProject.vue?vue&type=template&id=1d24733a&scoped=true"
import script from "./secProject.vue?vue&type=script&lang=js"
export * from "./secProject.vue?vue&type=script&lang=js"

import "./secProject.vue?vue&type=style&index=0&id=1d24733a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d24733a"]])

export default __exports__